/** Browser structured audit / diagnostic events (stdout of the browser console). */

export function logClientEvent(
  event: string,
  fields: Record<string, unknown> = {}
): void {
  console.info(
    JSON.stringify({
      event,
      ts: new Date().toISOString(),
      ...fields,
    })
  );
}
